import Vue from 'vue'
import Router from 'vue-router'

// import Todo from '@/components/Todo'
import Nothing from '@/components/Nothing'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Nothing,
      meta: { title: '登录' }
    }
  ]
})

// function generateRoutesFromMenu () {
//   // for (let i = 0, l = menu.length; i < l; i++) {
//   //   let item = menu[i]
//   //   if (item.path) {
//   //     routes.push(item)
//   //   }
//   // }
//   // return routes
//   return [{ path: '/Dept', components: {5: require('../components/Dept/Dept.vue')} }]
// }



// WEBPACK FOOTER //
// ./src/router/index.js